import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'
import { fieldNameOf } from './field-name-of.js'
import { fieldTypeOf } from './field-type-of.js'
import { hasChildFields } from './has-child-fields.js'

export function collectLocalListNameErrors(
  fields: GeneratedSchemaField[],
  pathPrefix: string,
  errors: string[]
): void {
  const seen = new Map<string, string>()

  for (const field of fields) {
    const name = fieldNameOf(field)
    const fieldPath = `${pathPrefix}.${name || fieldTypeOf(field)}`
    if (name) {
      const previous = seen.get(name)
      if (previous) {
        errors.push(`Duplicate list item field name "${name}" found at ${previous}, ${fieldPath}.`)
      } else {
        seen.set(name, fieldPath)
      }
    }

    if (hasChildFields(field)) {
      collectLocalListNameErrors(field.fields, `${fieldPath}.fields`, errors)
    }
  }
}
